import { FC } from 'react';

import { PLAN_CARD_TEST_ID } from '../constants';
import { HeadingLevel, PlanCardModel } from '../model';
import { SubTitleHeading } from '../PlanCard.styles';

type Props = { children: string; tag?: HeadingLevel } & PlanCardModel.NegativeProp;

export const SubTitle: FC<Props> = ({ children, isNegative, tag = 'h3' }) =>
    !!children && (
        <SubTitleHeading
            as={tag === 'none' ? 'div' : tag}
            $negative={isNegative}
            data-test={PLAN_CARD_TEST_ID.SUBTITLE}
        >
            {children}
        </SubTitleHeading>
    );
